var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: { title: "驳回项目报价", confirmLoading: _vm.loading },
      on: { ok: _vm.handleConfirm },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c(
        "div",
        { staticClass: "main_content" },
        [
          _c(
            "a-form-model",
            _vm._b(
              { ref: "form", attrs: { model: _vm.form, rules: _vm.rules } },
              "a-form-model",
              _vm.DEFAULT_FORM_LAYOUT,
              false
            ),
            [
              _c(
                "a-form-model-item",
                { attrs: { label: "驳回原因", prop: "rejectReason" } },
                [
                  _c("a-textarea", {
                    attrs: { rows: 4 },
                    model: {
                      value: _vm.form.rejectReason,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "rejectReason", $$v)
                      },
                      expression: "form.rejectReason",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }